import { Field, ObjectType } from "type-graphql";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

/** The error types for a client error. */
export enum ApplicationErrorType {
    Error = 'error',
    Warn = 'warn'
}
export enum ApplicationErrorTarget {
    Webapp = 'webapp',
    Server = 'server'
}

/**
 * When `console.error` is called on the client or server, this will be stored in the database for analytics.
 */
@Entity('application-error')
@ObjectType()
export default class ApplicationError {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** The message */
    @Column('mediumtext')
    @Field(() => String)
    public message: string

    /** The stack trace */
    @Column('mediumtext', {
        nullable: true
    })
    @Field(() => String, {
        nullable: true
    })
    public stackTrace: string | null

    /** The type of client error */
    @Column('enum', {
        enum: ApplicationErrorType
    })
    @Field(() => String)
    public type: ApplicationErrorType

    /** The target of the error */
    @Column('enum', {
        enum: ApplicationErrorTarget
    })
    @Field(() => String)
    public target: ApplicationErrorTarget = ApplicationErrorTarget.Webapp

    /** The amount of times this error has been registered by the client */
    @Column('int')
    @Field(() => Number)
    public count: number

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date
}